import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Separator"], {
        "data-slot": "sidebar-separator",
        "data-sidebar": "separator",
        class: _normalizeClass($setup.cn('bg-sidebar-border mx-2 w-auto', $setup.props.class))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class"]));
}
